import { forwardRef, useImperativeHandle } from 'react';
import { BrowseIcon } from 'tdesign-icons-react';
import { Button, Image, ImageViewer } from 'tdesign-react';

import styles from './index.module.less';

/**
 * 图片预览组件，支持传入图片数组，支持hover模式和点击模式
 */
export const BasicImageViewer = forwardRef((props: {
  images: string[];
  title?: string;
  hover?: boolean;
  defaultIndex?: number;
  styles?: React.CSSProperties;
  imageStyles?: React.CSSProperties;
  children?: React.ReactNode;
  showImage?: boolean; // 仅显示小图，不要icon
  handleDownload?: (url: string) => void;
  ref?: React.Ref<HTMLDivElement>;
}, ref) => {
  const { images = [], hover = true, defaultIndex, title, styles: pStyles, children, showImage = false } = props;
  const filterImages = images.filter(item => item);

  const trigger = ({ open }: { open: () => void }) => {
    const mask = (
      <div
        style={{
          background: 'rgba(0,0,0,.6)',
          color: '#fff',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
          position: 'absolute',
          width: '100%',
          cursor: 'pointer',
        }}
        onClick={open}
      >
        <span>
          <BrowseIcon size="12px" name={'browse'} />
        </span>
      </div>
    );

    useImperativeHandle(ref, () => ({
      open,
    }));

    return (
      <div className={styles.content} style={{ ...pStyles }}>
        {children}
        {hover
          ? (
            filterImages?.length && <div className={styles.mask}>{mask}</div>
          ) : (
            <div className={styles.btnWrapper}>
              {showImage
                ? <Image
                  src={filterImages[0]}
                  className={styles.image}
                  style={{ ...props.imageStyles }}
                  onClick={open}
                  loading={''}
                />
                : <Button
                  icon={<BrowseIcon size={14} />}
                  className={styles.btn}
                  variant="text"
                  onClick={open}
                />}
              {title && <div className={styles.title} onClick={open}>{title}</div>}
            </div>
          )}
      </div>
    );
  };

  return (
    <ImageViewer
      trigger={trigger}
      images={filterImages}
      defaultIndex={defaultIndex}
      closeOnOverlay={true}
      closeBtn={false}
      {...(props.handleDownload && {
        onDownload: v => props.handleDownload?.(v as string),
      })}
    />
  );
});
